/**
 * AppSidebar component
 * Modern left navigation with collapsed/expanded states
 */

import {
  Home,
  FolderKanban,
  CheckSquare,
  Calendar,
  FileText,
  FileSignature,
  Settings,
  User,
} from 'lucide-react';

import { useTranslation } from '@/lib/i18n/hooks/use-translation';

import { NavItem } from './components/NavItem';
import { RecentItems } from './components/RecentItems';
import { WorkspaceSwitcher } from './components/WorkspaceSwitcher';
import { useSidebarStore } from './store/sidebar-store';
import './AppSidebar.scss';

export function AppSidebar() {
  const { t } = useTranslation('common');
  const { isExpanded, setExpanded } = useSidebarStore();

  return (
    <aside
      className={`app-sidebar ${isExpanded ? 'app-sidebar-expanded' : ''}`}
      onMouseEnter={() => {
        setExpanded(true);
      }}
      onMouseLeave={() => {
        setExpanded(false);
      }}
    >
      <nav className="app-sidebar-nav">
        <div className="app-sidebar-main">
          <NavItem to="/" icon={Home} label={t('nav.home')} />
          <NavItem to="/projects" icon={FolderKanban} label={t('nav.projects')} />
          <NavItem to="/tasks" icon={CheckSquare} label={t('nav.tasks')} />
          <NavItem to="/calendar" icon={Calendar} label={t('nav.calendar')} />
          <NavItem to="/forms" icon={FileText} label={t('nav.forms')} />
          <NavItem to="/contracts" icon={FileSignature} label={t('nav.contracts')} />
        </div>

        <RecentItems />

        <div className="app-sidebar-bottom">
          <NavItem to="/settings" icon={Settings} label={t('nav.settings')} />
          <NavItem to="/profile" icon={User} label={t('nav.profile')} />
          <WorkspaceSwitcher />
        </div>
      </nav>
    </aside>
  );
}
